import {ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {AppointmentService} from "../services/appointment.service";
import {EMPTY, Observable, of} from "rxjs";
import {catchError, switchMap} from "rxjs/operators";
import {AppointmentModel} from "../../core/models/appointment.model";
import {UrlTreeHelper} from "../../core/services/url-tree-helper";

@Injectable()
export class AppointmentResolverGuard implements Resolve<any> {
  constructor(
    private appointmentService: AppointmentService,
    private router: Router,
    private urlTreeHelper: UrlTreeHelper,
  ) {
  }

  public resolve(route: ActivatedRouteSnapshot): Observable<any> {
    console.log("Resolving appointment for " + route.params['id']);
    const testRunParam = route.queryParamMap.get('testRun');
    const isTestRun = testRunParam === 'true';
    const BASE_PATH = '/' + route.params['factoryId'] + '/' + route.params['language'] + '/' + route.params['id'];
    return this.appointmentService.getAppointment(route.params['id'], route.params['factoryId'], route.params['language']).pipe(
      switchMap((data: AppointmentModel) => {
        if (data) {
          if (data.status !== 'OPEN' && !isTestRun) {
            this.router.navigateByUrl(this.urlTreeHelper.generateUrlTree(
              BASE_PATH, {prefix: '/processed'}));
          } else {
            return of(data);
          }
        } else {
          this.router.navigateByUrl(this.urlTreeHelper.generateUrlTree(
            BASE_PATH, {prefix: '/not-found'}));
        }
        return EMPTY;
      }),
      catchError((e) => {
        this.router.navigateByUrl(this.urlTreeHelper.generateUrlTree(
          BASE_PATH, {prefix: '/not-found'}));
        return EMPTY;
      })
    );
  }
}
